import { ProductBuilderMachineContext } from '../types';
import { getBaseProduct } from './getBaseProduct';

type GetProductType = (context: ProductBuilderMachineContext) => string | void;

export const getBaseProductType: GetProductType = context => {
  const baseProduct = getBaseProduct(context);

  let baseProductType = baseProduct
    ? baseProduct.type
    : context.products[0].type;

  if (
    window.location.pathname.includes('roller-day-night') &&
    baseProduct &&
    baseProduct.type === 'Roller Blind Single Chain'
  ) {
    baseProductType = 'Roller Blind Day/Night Chain';
  }
  if (
    window.location.pathname.includes('roller-day-night') &&
    baseProduct &&
    baseProduct.type === 'Roller Blind Single Chainless'
  ) {
    baseProductType = 'Roller Blind Day/Night Chainless';
  }

  const allowedBaseTypes = [
    'Honeycomb',
    'Roller Blind',
    'Roman Blinds',
    'Shutter',
    'Venetian',
    'Curtain',
  ];

  for (const baseType of allowedBaseTypes) {
    if (baseProductType.includes(baseType)) {
      return baseType;
    } else {
      continue;
    }
  }
};
